export enum ERROR {
    IS_REQUIRED = 'IS_REQUIRED',
    TOO_LARGE = 'TOO_LARGE',
    TOO_MANY = 'TOO_MANY',
}
